import { setSocketListener, removeSocketListener } from '../socket/socket'
import { ISocketStateRecover } from '../../types/socketStateRecover'

export const waitDataFromSocket = async <
  Response extends {
    type: string
  }
>(
  dataType: Response['type'],
  conditionChecker?: (data: Response) => boolean
): Promise<Response> => {
  return new Promise(resolve => {
    const onEvent = (data: ISocketStateRecover<Response> | Response) => {
      if ('socketType' in data) {
        if (data.socketType === 'stateRecover') {
          data.pastSocketsEventsData?.forEach(onEvent)
        }
        return
      }

      if (data.type !== dataType) {
        return
      }

      if (conditionChecker && !conditionChecker(data)) {
        return
      }

      removeSocketListener(onEvent)
      resolve(data)
    }

    setSocketListener(onEvent)
  })
}
